<template>
    <AdminProfile></AdminProfile>
</template>
<script>
    import AdminProfile from '@/components/AdminProfile.vue'
    export default {
        name: 'employee-home',
        components: {
            AdminProfile
        }
    }
</script>